module.exports = __webpack_public_path__ + "img/vip.9e020111.png";